<template>
  <div class="pb-6">
    <div v-if="!loading">
      <div class="customform-head">
        <div class="text-center customform-head-text"></div>
        <Typography
          h2
          medium
          fontColor="color-white"
          :text="project.projectname"
          class=""
        />
      </div>

      <div class="px-4 pt-3" style="background-color: #344e76;">
        <Typography
          h4
          medium
          fontColor="color-white"
          :text="
            `${currentStepIndex + 1}/${projectdata.length} ${form.formname}`
          "
        />
      </div>

      <div
        v-if="corditiondp && corditiondate"
        class="mt-3"
        style="max-width: 800px; margin-left: auto; margin-right: auto; padding: 0px 16px 0px 16px !important; "
      >
        <Btn
          v-if="query.mode != 'readonly'"
          white
          text="บันทึกแบบร่าง"
          radius="5"
          width="130"
          height="40"
          fontSize="16"
          semiBold
          @click="firstSubmitDraft"
          class="mx-2"
        />

        <v-container>
          <div class="text-right mb-3">
            <Btn
              v-if="history"
              blue
              text="ข้อมูลแบบฟอร์มก่อนหน้า"
              radius="5"
              width="210"
              height="40"
              fontSize="16"
              semiBold
              iconSize="26"
              icon="mdi-history"
              @click="showHistory = true"
              class="pa-2"
            />
          </div>
          <ValidationObserver ref="observer">
            <div v-for="(item, k) in allform" :key="k + ' ' + currentPage">
              <form-item
                :vid="k + '_' + currentPage"
                v-model="item.value"
                :value2.sync="item.value2"
                :Options="item.Options"
                :Options2="item.Options2"
                :cap="RegisterCapital"
                :paidcap="PaidRegisterCapital"
                :formdata="item"
                :shopInfo="shopInfo"
                :productInfo="productInfo"
              ></form-item>
            </div>
          </ValidationObserver>
        </v-container>
        <div>
          <v-dialog v-model="showHistory" width="700px">
            <v-card v-if="showHistory">
              <div class="text-right">
                <v-btn @click="showHistory = false" icon
                  ><v-icon>close</v-icon>
                </v-btn>
              </div>
              <div class="pa-5">
                <div v-for="(item, k) in allformHistory" :key="k" class="Kanit">
                  <form-item
                    :readonly="true"
                    v-model="item.value"
                    :formdata="item"
                    :value2.sync="item.value2"
                    :Options="item.Options"
                  ></form-item>
                </div>
                <div class="px-3">
                  <v-row dense class="ma-0 pa-0">
                    <v-col cols="6" class="pr-5">
                      <div v-if="totalPageHistory !== 0">
                        <Btn
                          white
                          v-if="currentPageHistory !== 0"
                          text="ย้อนกลับ"
                          radius="5"
                          width="100"
                          height="40"
                          fontSize="16"
                          semiBold
                          @click="prevPageHistory"
                          icon="mdi-chevron-left"
                          iconSize="24"
                        />
                      </div>
                    </v-col>
                    <v-col cols="6" class="pl-5">
                      <div v-if="totalPageHistory !== 0" class="text-right">
                        <Btn
                          white
                          v-if="
                            totalPageHistory !== 0 &&
                              totalPageHistory - 1 !== currentPageHistory
                          "
                          text="ถัดไป"
                          radius="5"
                          width="100"
                          height="40"
                          fontSize="16"
                          semiBold
                          @click="nextPageHistory"
                          iconRightText="mdi-chevron-right"
                          iconSize="24"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card>
          </v-dialog>
        </div>
        <div v-if="query.mode != 'readonly'">
          <v-row class="pa-0 ma-0" justify="center">
            <v-col>
              <div
                v-if="
                  totalPage == 1 ||
                    totalPage == currentPage + 1 ||
                    totalPage === 0
                "
                class="submitbtn pb-6 mt-2"
              >
                <v-btn
                  depressed
                  :loading="saveloading"
                  @click="submitData(true)"
                  color="primary"
                  block
                  class="text-capitalize"
                  >{{ formdata.button ? formdata.button : "ดำเนินการ" }}</v-btn
                >
                <v-btn
                  outlined
                  block
                  :loading="saveloading"
                  @click="submitData(false, formdata.reject)"
                  color="primary"
                  dark
                  class="text-capitalize mt-3"
                  >{{ formdata.reject ? formdata.reject : "ปฏิเสธ" }}</v-btn
                >
              </div></v-col
            >
          </v-row>
        </div>
        <div class="px-3">
          <v-row dense class="ma-0 pa-0">
            <v-col cols="6" class="pr-5">
              <div v-if="totalPage !== 0">
                <Btn
                  white
                  v-if="currentPage !== 0"
                  text="ย้อนกลับ"
                  radius="5"
                  width="100"
                  height="40"
                  fontSize="16"
                  semiBold
                  @click="prevPage"
                  icon="mdi-chevron-left"
                  iconSize="24"
                />
              </div>
            </v-col>
            <v-col cols="6" class="pl-5">
              <div v-if="totalPage !== 0" class="text-right">
                <Btn
                  white
                  v-if="totalPage !== 0 && totalPage - 1 !== currentPage"
                  text="ถัดไป"
                  radius="5"
                  width="100"
                  height="40"
                  fontSize="16"
                  semiBold
                  @click="nextPage"
                  iconRightText="mdi-chevron-right"
                  iconSize="24"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <!-- <div class="d-flex justify-content-around">
          <Btn
            style="width:48%;"
            class="d-flex justify-center"
            white
            text="back"
            radius="25"
            width="100"
            height="40"
            fontSize="16"
            bold
            medium
            semiBold
            @click="currentPage -= 1"
          />
          <Btn
            class="d-flex justify-center"
            style="width:48%;"
            white
            text="next"
            radius="25"
            width="100"
            height="40"
            fontSize="16"
            bold
            medium
            semiBold
            @click="currentPage += 1"
          />
        </div> -->
      </div>

      <div v-else>
        <v-layout v-if="!corditiondate" row wrap justify-center>
          <h4 class="text-center mt-10">โครงการนี้อยู่นอกเวลาการทำการ</h4>
        </v-layout>
        <v-layout v-else-if="!corditiondp" row wrap justify-center>
          <h4 class="text-center mt-10" v-if="memberData.dptype == 'Non-DP'">
            ไม่สามารถใช้งานแบบฟอร์มนี้ได้ เนื่องจากผู้กรอกข้อมูลต้องมีสถานะเป็น
            DP
          </h4>
          <h4 class="text-center mt-10" v-else-if="memberData.dptype == 'DP'">
            ไม่สามารถใช้งานแบบฟอร์มนี้ได้ เนื่องจากผู้กรอกข้อมูลต้องมีสถานะเป็น
            Non-DP
          </h4>
          <h4 class="text-center mt-10" v-else>
            ไม่สามารถใช้งานแบบฟอร์มนี้ได้
            เนื่องจากผู้กรอกข้อมูลต้องมีสถานะไม่ถูกต้อง
          </h4>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
import FormItem from "./FormItem";
import moment from "moment";
export default {
  components: {
    FormItem,
  },
  data() {
    return {
      dbd: null,
      showHistory: false,
      history: "",
      project: {},
      alreadyInput: false,
      lastStep: false,
      saveloading: false,
      formdata: {},
      form: {},
      projectdata: {},
      typedata: {},
      input: [],
      steps: [],
      loading: true,
      customformid: "",
      confirmproject: "",
      currentStepIndex: "",
      currentStepProjectDataIndex: "",
      totalPage: 0,
      currentPage: 0,
      totalPageHistory: 0,
      currentPageHistory: 0,
      draft: null,
      shopInfo: {},
      productInfo: {},
      agency: null,
    };
  },
  async mounted() {
    // await this.getdata();
    this.loading = true;
    await this.getProject();
    if (this.query.agencyid) {
      await this.getAgency();
    }
    if (this.memberData && this.memberData.id_card) {
      this.getDBD(this.memberData.id_card);
    }

    if (this.query.techproviderid) {
      this.getShopData(this.query.techproviderid);
    }
    if (this.query.t_product_id) {
      this.getProductData(this.query.t_product_id);
    }

    // check can submit
    if (
      (this.query.first == true || this.query.first == "true") &&
      this.query.edit != "true"
    ) {
      let canSubmit = await this.checkCanSubmit(
        this.memberData.memberid,
        this.query.projectid
      );
      if (!canSubmit) {
        let resBtn = await this.$swal.fire({
          type: "warning",
          icon: "warning",
          title: "ท่านเคยสมัครโครงการนี้ไปแล้ว ต้องการสมัครใหม่หรือไม่",
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        });
        if (!resBtn.isConfirmed) {
          this.$liff.closeWindow();
          window.close();
        }
      }
    }
    // await this.getapplicant()
    this.steps = [];
    this.typedata.forEach((el) => {
      this.steps = [...this.steps, ...el.steps];
    });
    if (this.steps.length <= 1) {
      return (this.query.view = "ShowError");
    }
    if (this.query.current_stepid) {
      this.currentStepIndex = this.steps.findIndex(
        (el) => el.id == this.query.current_stepid
      );
      this.currentStepProjectDataIndex = this.projectdata.findIndex(
        (el) => el.stepid == this.query.current_stepid
      );
    } else {
      this.currentStepIndex = 0;
      this.currentStepProjectDataIndex = 0;
    }

    this.lastStep = this.steps.length - 1 == this.currentStepIndex;
    if (this.query.mode == "readonly") {
      await this.getRead();
    } else {
      if (this.query.first != "true") {
        if (this.query.mode != "readonly") {
          await this.getHistory();
        }
        await this.getLastForm();
      }
      if (!this.alreadyInput) {
        await this.getForm();
        if (this.query.edit != "true") {
          this.draft = await api.getDraft(
            this.memberid,
            this.projectid,
            this.form.id
          );
        }
        try {
          if (this.draft && this.draft.formdata) {
            this.formdata.formitems = [
              ...{ ...JSON.parse(this.draft.formdata) }.formitems,
            ];
          }
        } catch (error) {
          console.error(error);
        }
      }
      if (this.query.edit == "true" && this.query.applicantid) {
        this.draft = await api.getEdit(
          this.memberid,
          this.query.applicantid,
          this.form.id
        );
        this.draft = this.draft && this.draft[0] ? this.draft[0] : null;
        try {
          if (this.draft && this.draft.formdata) {
            this.formdata.formitems = [
              ...{ ...JSON.parse(this.draft.formdata) }.formitems,
            ];
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    this.loading = false;
  },
  computed: {
    formdataDraft() {
      let data = null;
      try {
        if (this.draft && this.draft.formdata) {
          data = JSON.parse(this.draft.formdata);
        }
      } catch (error) {
        console.error(error);
      }
      return data;
    },
    projectid() {
      return this.query && this.query.projectid ? this.query.projectid : null;
    },
    memberid() {
      return this.memberData && this.memberData.memberid
        ? this.memberData.memberid
        : null;
    },
    corditiondp() {
      if (!this.loading) {
        if (!this.foruser.includes("DP") && !this.foruser.includes("Non-DP")) {
          return true;
        }
        if (
          this.currentStepIndex == 0 &&
          this.memberData.dptype &&
          this.foruser.includes(this.memberData.dptype)
        ) {
          return true;
        } else if (this.currentStepIndex > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    corditiondate() {
      if (this.currentStepIndex != 0) {
        return true;
      } else {
        if (!this.form.draft) {
          return true;
        }
      }
      if (
        this.project &&
        this.project.showstartdate &&
        this.project.showenddate
      ) {
        let start = this.project.showstartdate;
        let end = this.project.showenddate;
        let curr = new Date();
        start = new Date(start);
        end = new Date(end);
        curr.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        if (curr >= start && curr <= end) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    memberData() {
      return this.$store.state.memberData;
    },
    foruser() {
      return this.project && this.project.foruser
        ? this.project.foruser.split(",")
        : [];
    },
    dbdData() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0]
        ? this.dbd.data.data.ResultList[0]
        : null;
    },
    RegisterCapital() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0] &&
        (this.dbd.data.data.ResultList[0].RegisterCapital || this.dbd.data.data.ResultList[0]["cd:OrganizationJuristicRegisterCapital"])
        ? (this.dbd.data.data.ResultList[0].RegisterCapital || this.dbd.data.data.ResultList[0]["cd:OrganizationJuristicRegisterCapital"])
        : null;
    },
    PaidRegisterCapital() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0] &&
        (this.dbd.data.data.ResultList[0].PaidRegisterCapital || this.dbd.data.data.ResultList[0]["cd:OrganizationJuristicPaidUpCapital"])
        ? (this.dbd.data.data.ResultList[0].PaidRegisterCapital || this.dbd.data.data.ResultList[0]["cd:OrganizationJuristicPaidUpCapital"])
        : null;
    },
    allform() {
      var result = this.formdata.formitems;
      // console.log(result);
      // result.unshift({
      //   Options: "",
      //   fields: [],
      //   isRequired: true,
      //   name: "ที่อยู่",
      //   questiontype: "ที่อยู่",
      //   value: "",
      //   value2: "",
      // });
      // result.unshift({
      //   Options: "",
      //   digitPosition: 0,
      //   fields: Array[0],
      //   fields2: Array[0],
      //   filename: "filename",
      //   fileurl: "https://depa.s3.amazonaws.com/prd/1641978653069zwizshop.xlsx",
      //   isRequired: false,
      //   name: "",
      //   questiontype: "ตัวอย่างไฟล์",
      //   value: "",
      //   value2: "",
      // });
      // result.unshift({
      //   name: "ทดสอบ",
      //   questiontype: "หลายตัวเลือก",
      //   fields: [
      //     { label: "ddd", subquestion: [] },
      //     { label: "eee", subquestion: [] },
      //   ],
      //   isRequired: false,
      //   value: "",
      //   value2: "",
      //   fields2: [],
      //   digitPosition: 0,
      //   filename: "",
      //   fileurl: "",
      //   defaultOptions: "eee",
      //   Options: "",
      // });
      // result.unshift({
      //   name: "ทดสอบ2",
      //   hideFromMember: true,
      //   questiontype: "ช่องทำเครื่องหมาย",
      //   fields: [
      //     { label: "หมู", subquestion: [] },
      //     { label: "เห็ด", subquestion: [] },
      //     { label: "เป็ด", subquestion: [] },
      //     { label: "ไก่", subquestion: [] },
      //   ],
      //   isRequired: false,
      //   value: "",
      //   value2: "",
      //   digitPosition: 0,
      //   filename: "",
      //   fileurl: "",
      //   defaultOptions: ["เป็ด", "หมู"],
      //   Options: "",
      // });
      if (result) {
        if (result.some((el) => el.questiontype == "หน้าถัดไป")) {
          var data = [];
          var count = 0;
          // eslint-disable-next-line no-continue
          result.map((el, index) => {
            if (el.questiontype == "หน้าถัดไป") {
              count += 1;
            } else {
              // eslint-disable-next-line no-continue4
              if (data[count]) {
                data[count].push(el);
              } else {
                data.push([el]);
              }
            }
          });
          this.totalPage = data.length;
          return data[this.currentPage];
        } else {
          return result;
        }
      }
    },
    // allformDraft() {
    //   var result = this.formdataDraft.formitems;
    //   if (result) {
    //     if (result.some((el) => el.questiontype == "หน้าถัดไป")) {
    //       var data = [];
    //       var count = 0;
    //       // eslint-disable-next-line no-continue
    //       result.map((el, index) => {
    //         if (el.questiontype == "หน้าถัดไป") {
    //           count += 1;
    //         } else {
    //           // eslint-disable-next-line no-continue4
    //           if (data[count]) {
    //             data[count].push(el);
    //           } else {
    //             data.push([el]);
    //           }
    //         }
    //       });
    //       this.totalPage = data.length;
    //       return data[this.currentPage];
    //     } else {
    //       return result;
    //     }
    //   }
    // },
    allformHistory() {
      var result = this.history.formdata.formitems;
      if (result) {
        if (result.some((el) => el.questiontype == "หน้าถัดไป")) {
          var data = [];
          var count = 0;
          // eslint-disable-next-line no-continue
          result.map((el, index) => {
            if (el.questiontype == "หน้าถัดไป") {
              count += 1;
            } else {
              // eslint-disable-next-line no-continue4
              if (data[count]) {
                data[count].push(el);
              } else {
                data.push([el]);
              }
            }
          });
          this.totalPageHistory = data.length;
          return data[this.currentPageHistory];
        } else {
          return result;
        }
      }
    },
  },
  methods: {
    async saveDraft() {},
    async nextPage() {
      let veli = await this.$refs.observer.validate();
      // console.log(veli);
      if (veli) {
        this.currentPage += 1;
      } else {
        await this.$nextTick();
        const el = document.querySelector(".v-input.error--text");
        el.scrollIntoView();
      }
    },
    async prevPage() {
      this.currentPage -= 1;
      // let veli = await this.$refs.observer.validate();
      // console.log(veli);
      // if (veli) {
      //   this.currentPage -= 1;
      // }
    },
    async nextPageHistory() {
      this.currentPageHistory += 1;
      // if (await this.$refs.observer.validate()) {
      //   this.currentPageHistory += 1;
      // }
    },
    async prevPageHistory() {
      this.currentPageHistory -= 1;
      // if (await this.$refs.observer.validate()) {
      //   this.currentPageHistory -= 1;
      // }
    },
    async submitData(confirmation, messgae = "") {
      let rejectMessage = messgae ? messgae : "";
      if (this.query.first == "true" && !confirmation) {
        await this.$liff.closeWindow();
      }
      var isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.$swal
          .fire({
            title: "ยืนยันการทำรายการ?",
            showCancelButton: true,
            reverseButtons: true,
            icon: "question",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
          })
          .then((result) => {
            if (result.value) {
              if (this.query.first == "true") {
                this.firstSubmit();
              } else {
                this.nextSubmit(confirmation, rejectMessage);
              }
            }
          });
      } else {
        await this.$nextTick();
        const el = document.querySelector(".v-input.error--text");
        el.scrollIntoView();
      }
    },
    async getHistory() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "depaapplicantdetailwithstepid", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              memberid: this.query.previous_memberid, // ส่งไปใน query => previous_memberid
              applicantid: this.query.applicantid, // ส่งไปใน query
              stepid: this.query.previous_stepid, // ส่งไปใน query => previous_stepid
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.history = response.data.data[0].data;
              this.history = this.history.map((el) => {
                return { ...el, formdata: JSON.parse(el.formdata) };
              })[0];
            }
            resolve();
          });
      });
    },
    async checkCanSubmit(memberid, projectid) {
      return new Promise((resolve) => {
        axios
          .post(
            this.serverUrl + "checkCanSubmit",
            {
              memberid,
              projectid,
            },
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then((response) => {
            if (response.data.responsecode == 200 && response.data.data) {
              resolve(response.data.data);
            }
            resolve(false);
          });
      });
    },
    async nextSubmit(confirmation, rejectMessage = "") {
      if (
        this.steps &&
        this.steps.length > 1 &&
        this.steps[this.currentStepIndex + 1]
      ) {
        var stepid = this.steps[this.currentStepIndex + 1].id;
      } else {
        var stepid = null;
      }
      // this.projectdata
      var vm = this;
      var tags = "";
      var currentprojectdata = this.projectdata[
        this.currentStepProjectDataIndex
      ];
      if (currentprojectdata.tags) {
        if (Array.isArray(currentprojectdata.tags)) {
          tags = currentprojectdata.tags.join(",");
        } else tags = currentprojectdata.tags;
      }
      var data = {
        tags,
        dpType: currentprojectdata.dpType,
        userid: this.userid,
        memberid: this.$store.state.profiledata.memberid,
        projectid: this.query.projectid,
        formid: this.customformid, // id ของ form ที่กรอ
        formdata: JSON.stringify({
          ...this.formdata,
          projectname: this.project.projectname,
          memberid: this.$store.state.memberid,
          profiledata: this.$store.state.profiledata,
          formname: this.form.formname,
          timestamp: moment().format("YYYY-MM-DD HH:mm"),
        }), // ข้อมูลที่กรอกในform
        current_stepid: this.query.current_stepid, // stepid ถัดไป ไม่มีส่ง null
        next_stepid: stepid, // stepid ถัดไป ไม่มีส่ง null
        applicantid: this.query.applicantid, // ส่งไปใน query
        confirmproject: confirmation, // ส่งมาตอนฟอร์มสุดท้ายที่เป็นอนุมัติหรือไม่ ถ้าอนุมัติส่ง true ถ้าไม่ส่ง false
        rejectMessage,
      };
      return new Promise((resolve) => {
        vm.saveloading = true;
        axios
          .post(this.serverUrl + "depaconfirmapplication", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data.responsecode == 200) {
              await this.$swal.fire({
                text: "สำเร็จ",
                confirmButtonText: "ยืนยัน",
                confirmButtonColor: "#152d53",
              });
              this.$liff.closeWindow();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
            }
          });
      });
    },
    async firstSubmit() {
      if (this.steps && this.steps.length > 1 && this.steps[1]) {
        var stepid = this.steps[1].id;
      } else {
        var stepid = null;
      }
      var vm = this;
      var tags = "";
      var currentprojectdata = this.projectdata[
        this.currentStepProjectDataIndex
      ];
      if (currentprojectdata.tags) {
        if (Array.isArray(currentprojectdata.tags)) {
          tags = currentprojectdata.tags.join(",");
        } else tags = currentprojectdata.tags;
      }
      var data = {
        tags,
        dpType: currentprojectdata.dpType,
        userid: this.userid,
        projectid: this.query.projectid,
        memberid: this.$store.state.profiledata.memberid,
        formid: this.customformid, // id ของ form ที่กรอ
        formdata: JSON.stringify({
          ...this.formdata,
          projectname: this.project.projectname,
          memberid: this.$store.state.memberid,
          profiledata: this.$store.state.profiledata,
          formname: this.form.formname,
          timestamp: moment().format("YYYY-MM-DD HH:mm"),
        }), // ข้อมูลที่กรอกในform
        current_stepid: this.steps[0].id, // stepid ของ form ถัดไป
        next_stepid: stepid, // stepid ของ form ถัดไป
      };
      if (this.query.applicantid && this.query.edit == "true") {
        data.pa_id = this.query.applicantid;
      }

      return new Promise((resolve) => {
        vm.saveloading = true;
        axios
          .post(this.serverUrl + "depaapplyprojectform", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data.responsecode == 200) {
              await this.$swal.fire({
                title: "สำเร็จ",
                icon: "success",
                confirmButtonText: "ปิด",
                confirmButtonColor: "#152d53",
              });
              this.$liff.closeWindow();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
            }
          });
      });
    },
    async firstSubmitDraft() {
      if (this.steps && this.steps.length > 1 && this.steps[1]) {
        var stepid = this.steps[1].id;
      } else {
        var stepid = null;
      }
      var vm = this;
      var tags = "";
      var currentprojectdata = this.projectdata[
        this.currentStepProjectDataIndex
      ];
      if (currentprojectdata.tags) {
        if (Array.isArray(currentprojectdata.tags)) {
          tags = currentprojectdata.tags.join(",");
        } else tags = currentprojectdata.tags;
      }
      var data = {
        tags,
        dpType: currentprojectdata.dpType,
        userid: this.userid,
        projectid: this.query.projectid,
        memberid: this.$store.state.profiledata.memberid,
        formid: this.customformid, // id ของ form ที่กรอ
        formdata: JSON.stringify({
          ...this.formdata,
          projectname: this.project.projectname,
          memberid: this.$store.state.memberid,
          profiledata: this.$store.state.profiledata,
          formname: this.form.formname,
          timestamp: moment().format("YYYY-MM-DD HH:mm"),
        }), // ข้อมูลที่กรอกในform
        current_stepid: this.steps[0].id, // stepid ของ form ถัดไป
        next_stepid: stepid, // stepid ของ form ถัดไป
      };

      return new Promise((resolve) => {
        vm.saveloading = true;
        axios
          .post(this.serverUrl + "depaapplyprojectformdraft", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data.responsecode == 200) {
              await this.$swal.fire({
                type: "success",
                title: "บันทึกแบบร่างสำเร็จ",
                icon: "success",
                confirmButtonText: "ปิด",
                confirmButtonColor: "#152d53",
              });
              // this.$liff.closeWindow();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
            }
          });
      });
    },
    async saveData() {
      await this.$swal.fire({
        icon: "success",
        text: "สำเร็จ",
      });
      this.$liff.closeWindow();
    },
    getForm() {
      return new Promise((resolve) => {
        if (this.query.first == "true") {
          this.customformid = this.typedata[0].steps[0].customform;
        } else {
          this.customformid = this.steps.find((el) => {
            return el.id == this.query.current_stepid;
          }).customform;
        }
        axios
          .get(this.serverUrl + "getdepaprojectformbyid", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              customform: this.customformid,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.form = response.data.data[0].data[0];
              this.formdata = JSON.parse(this.form.formdata);
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode != 300) {
                await this.$liff.closeWindow();
              }
              resolve();
            }
          });
      });
    },
    getLastForm() {
      if (this.query.first == "true") {
        this.customformid = this.typedata[0].steps[0].customform;
      } else {
        this.customformid = this.steps.find((el) => {
          return el.id == this.query.current_stepid;
        }).customform;
      }
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "depaapplicantdetaillastconfirm", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              memberid: this.$store.state.profiledata.memberid,
              applicantid: this.query.applicantid,
              stepid: this.query.current_stepid,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              if (response.data.data.length) {
                this.form = response.data.data[0].data[0];
                this.formdata = JSON.parse(this.form.formdata);
                this.alreadyInput = true;
              }
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode != 300) {
                await this.$liff.closeWindow();
              }
            }
            resolve();
          });
      });
    },
    getRead() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "depareadapplicantdetail", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              memberid: this.query.member_id,
              applicantid: this.query.applicantid,
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.form = response.data.data[0].data[0];
              this.formdata = JSON.parse(this.form.formdata);

              resolve();
            }
          });
      });
    },
    // getapplicant(){

    // },
    getProject() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "getdepaprojectbyid", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },

            params: {
              projectid: this.query.projectid,
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.project = response.data.data[0].data[0];
              this.$store.state.projects = response.data.data[0].data[0];
              this.projectdata = JSON.parse(this.project.projectdata);
              this.typedata = JSON.parse(this.project.typedata);
            } else {
              this.$swal.fire({
                text: response.data.reason,
              });
            }
            resolve();
          });
      });
    },
    getAgency() {
      return new Promise((resolve) => {
        axios
          .get(`${this.serverUrl}liff/getDepaAgency/${this.query.agencyid}`, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200) {
              this.agency = response.data.data;
              this.$store.state.agency = response.data.data;
            } else {
              this.$swal.fire({
                text: response.data.reason,
              });
            }
            resolve();
          });
      });
    },
    async getDBD(id) {
      let data = await api.getdbdData(id);
      this.dbd = data;
    },
    async getShopData(id) {
      return new Promise((resolve) => {
        axios
          .post(
            this.serverUrl + `getDefaultValueByTechproviderId/${id}`,
            {},
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then((response) => {
            if (
              response.data.responsecode == 200 &&
              response.data.data.memberid
            ) {
              this.shopInfo = response.data.data;
            } else {
              this.shopInfo = {
                memberid: "",
                JuristicID: "",
                RegisterCapital: "",
                PaidRegisterCapital: "",
              };
            }
            resolve();
          });
      });
    },
    async getProductData(id) {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + `getDefaultValueByProductId/${id}`, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then((response) => {
            if (response.data.responsecode == 200 && response.data.data) {
              this.productInfo = {
                typename: response.data.data.typename
                  ? response.data.data.typename
                  : "",
                categoryname: response.data.data.categoryname
                  ? response.data.data.categoryname
                  : "",
              };
            } else {
              this.productInfo = {
                typename: "",
                categoryname: "",
              };
            }
            resolve();
          });
      });
    },

    async next() {
      await this.$liff.sendMessages([
        {
          type: "text",
          text: "สมัครโครงการสำเร็จ",
        },
      ]);
      await this.$liff.closeWindow();
    },
  },
};
</script>

<style lang="scss">
.customform-head {
  height: 80px;
  padding-top: 10px;
  background-color: #152d53;
  display: flex;
  justify-content: center;
}
.customform-head-text {
  line-height: 22px;
  font-size: 23px;
  font-weight: 400;
  color: white;
  align-self: center;
  word-break: break-word;
}
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: rgba(0, 0, 0, 0.58) !important;
  /* background-color: #eee; */
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: rgba(0, 0, 0, 0.26);
  background-color: #eee !important;
}
</style>
